
import {Component, Prop, Vue} from "vue-property-decorator";
import dataFieldTypesReadonly from "@/dataFieldReadonlyTypes";
import ReadonlyDataField from "@/models/ReadonlyDataField";

@Component({
  name: 'DataFieldsReadonly',
  components: {
    ...dataFieldTypesReadonly,
  },
})
export default class DataFieldsReadonly extends Vue {

  @Prop({required: true})
  dataFields: Array<ReadonlyDataField>;

  getDefinitionType(dataField: ReadonlyDataField) {
    if (dataField.definitionType == "ListEntry" && dataField.identifier == "aeReport") {
      // some old ae reports were saved as ListEntry
      // this workaround forces ae reports to be displayed as EventReportListEntry, otherwise there may be a missing
      // ListField component with expansionpanels tag
      return "EventReportListEntry";
    }

    return dataField.definitionType;
  }
}
